// CurrencySpreading.js
import React, { useState } from "react";
import MainCalculatorsList from "./MainCalculators";
import RelatedLinks from "../RelatedLinks";
import { SecondAds,    FirstAds , MobileUnderCalAds } from "../../Ads";
import SharedHelmet from "../Helmet";
const TITLE = "Kalkulator Mata Uang - Konversi Angka ke Teks Bahasa Indonesia";
const DESCRIPTION =
  "Hitung nilai sejumlah uang tertentu dalam mata uang pilihan Anda sebagai angka dan teks bahasa Indonesia. Kalkulator ini membantu Anda mengetahui cara menulis jumlah uang dalam angka dan kata-kata.";
const KEYWORDS = "kalkulator, mata uang, konversi, angka, teks, Rupiah, Ringgit, Dolar";
const OG_URL = "https://do-calculate.com/calculator/id/currency-spreader/";

function numberToIndonesianText(num) {
  const ones = [
    "", "satu", "dua", "tiga", "empat", "lima", "enam", "tujuh", "delapan", "sembilan"
  ];
  const teens = [
    "sepuluh", "sebelas", "dua belas", "tiga belas", "empat belas", "lima belas",
    "enam belas", "tujuh belas", "delapan belas", "sembilan belas"
  ];
  const tens = [
    "", "sepuluh", "dua puluh", "tiga puluh", "empat puluh", "lima puluh",
    "enam puluh", "tujuh puluh", "delapan puluh", "sembilan puluh"
  ];
  const hundreds = [
    "", "seratus", "dua ratus", "tiga ratus", "empat ratus", "lima ratus",
    "enam ratus", "tujuh ratus", "delapan ratus", "sembilan ratus"
  ];
  
  if (num === 0) return "nol";
  
  let str = "";
  if (num >= 100) {
    str += hundreds[Math.floor(num / 100)] + " ";
    num %= 100;
  }
  if (num >= 20) {
    str += tens[Math.floor(num / 10)] + " ";
    num %= 10;
  }
  if (num >= 10 && num < 20) {
    str += teens[num - 10] + " ";
    num = 0;
  }
  if (num > 0) {
    if (str !== "") {
      str += "";
    }
    str += ones[num] + " ";
  }
  return str.trim();
}

function CurrencyConverter() {
  const [amount, setAmount] = useState("0");
  const [currency, setCurrency] = useState("Rupiah Indonesia");
  const [convertedAmount, setConvertedAmount] = useState(null);
  const [error, setError] = useState("");
  const calculateConvertedAmount = () => {
    try {
      if (amount === "0") {
        setError("Silakan masukkan jumlah uang untuk dikonversi");
        return;
      }
      const indonesianText = numberToIndonesianText(Number(amount));
      const conversion = `${indonesianText} ${currency}`;
      setConvertedAmount(conversion);
    } catch (error) {
      setError(error.message);
    }
  };
  return (
    <div className="ltr">
      <SharedHelmet
        TITLE={TITLE}
        DESCRIPTION={DESCRIPTION}
        KEYWORDS={KEYWORDS}
        OG_URL={OG_URL}
      />
      <div className="row">
        <div className="col-12 col-md-8">
          <FirstAds />
        </div>
      </div>
      <div className="row">
        <div className="col-12 col-md-8">
          <br />
          <div
            className="bg-success text-white text-center"
            style={{ height: "50px" }}
          >
            <h1 style={{ fontSize: "17px" }}>{TITLE}</h1>
          </div>
          <div className="border border-light">
            <div className="row">
              <div>
                <p>
                  Kalkulator ini menyediakan cara sederhana untuk mengkonversi angka menjadi teks bahasa Indonesia
                  dan menambahkannya ke mata uang yang dipilih. Anda dapat dengan mudah mengetahui cara menulis
                  jumlah uang dalam angka dan kata-kata secara bersamaan.
                </p>
                <p>
                  Misalnya, jika Anda memiliki jumlah 500 Rupiah Indonesia, kalkulator akan mengkonversi angka
                  menjadi teks bahasa Indonesia "lima ratus Rupiah Indonesia". Informasi ini berguna dalam
                  berbagai aplikasi seperti menulis cek atau kontrak.
                </p>
                <hr />
              </div>
            </div>
             <MobileUnderCalAds />
            <div className="row">
              <div className="col-sm-12 col-md-7 calculatorStyle">
                <div className="p-3 mb-2 bg-success text-white">
                  <h2 style={{ fontSize: "16px" }}>{TITLE}</h2>
                </div>
                <div className="p-3">
                  <div className="form-group d-flex align-items-center">
                    <label htmlFor="amount">Jumlah Uang:</label>
                    <input
                      id="amount"
                      type="number"
                      value={amount}
                      onChange={(e) => setAmount(e.target.value)}
                      className="form-control"
                      style={{ width: "75%" }}
                    />
                  </div>
                  <div className="form-group d-flex align-items-center">
                    <label htmlFor="currency">Mata Uang:</label>
                    <select
                      id="currency"
                      value={currency}
                      onChange={(e) => setCurrency(e.target.value)}
                      className="form-control"
                      style={{ width: "75%" }}
                    >
                      <option value="Rupiah Indonesia">Rupiah Indonesia</option>
                      <option value="Ringgit Malaysia">Ringgit Malaysia</option>
                      <option value="Dolar Singapura">Dolar Singapura</option>
                      <option value="Baht Thailand">Baht Thailand</option>
                      <option value="Dolar Amerika">Dolar Amerika</option>
                      <option value="Euro">Euro</option>
                      <option value="Poundsterling Inggris">Poundsterling Inggris</option>
                      <option value="Yen Jepang">Yen Jepang</option>
                      <option value="Won Korea">Won Korea</option>
                      <option value="Dolar Australia">Dolar Australia</option>
                      <option value="Dolar Selandia Baru">Dolar Selandia Baru</option>
                    </select>
                  </div>
                  <br />
                  <button
                    className="btn btn-success"
                    style={{ fontSize: "20px", marginLeft: "10px" }}
                    onClick={calculateConvertedAmount}
                  >
                    Hitung
                  </button>
                </div>
                { error !== "" ? (
                  <p className="p-3 mb-2 bg-warning text-white">Error: {error}</p>
                ) : (
                  convertedAmount !== null && (
                    <div className="p-3 mb-2 bg-success text-white">
                      <p>Jumlah yang dikonversi: {convertedAmount}</p>
                    </div>
                  )
                )}
              </div>
            </div>
            <hr /><div className="row">
              <RelatedLinks />
              <hr />
            </div>
          </div>
        </div>
        <div className="col">
          <SecondAds />
          <br />
          <MainCalculatorsList />
          <br />
        </div>
      </div>
      <div className="row" style={{ height: "auto" }}>
        <div className="col-12 col-md-8">
          <div className="info-sections-container">
            <div className="info-section">
              <div className="info-section-header">Cara Mengkonversi Angka ke Teks</div>
              <div className="info-section-body">
                <div>
                  <u>
                    <h2 style={{ fontSize: "16px" }}>
                      Langkah 1: Tentukan Jumlah Uang yang Akan Dikonversi
                    </h2>
                  </u>
                  <p>
                    Pertama, Anda perlu mengetahui jumlah uang yang ingin Anda konversi dari
                    angka ke teks. Pastikan untuk memasukkan jumlah yang benar di tempat yang disediakan.
                  </p>
                  <br />
                </div>
                <hr />
                <div>
                  <u>
                    <h2 style={{ fontSize: "16px" }}>
                      Langkah 2: Pilih Mata Uang
                    </h2>
                  </u>
                  <p>
                    Setelah menentukan jumlah uang, pilih mata uang yang ingin Anda tambahkan ke
                    jumlah dalam bentuk teks. Pilih dari mata uang yang tersedia.
                  </p>
                  <br />
                </div>
                <hr />
                <div>
                  <u>
                    <h2 style={{ fontSize: "16px" }}>
                      Langkah 3: Konversi Angka ke Teks
                    </h2>
                  </u>
                  <p>
                    Sekarang setelah memasukkan jumlah uang dan memilih mata uang, kalkulator akan mengkonversi
                    angka menjadi teks bahasa Indonesia dan menambahkan mata uang yang dipilih.
                  </p>
                  <div className="p-3 mb-2 bg-info text-black ">
                    Contoh: 500 Rupiah Indonesia = lima ratus Rupiah Indonesia.
                  </div>
                  <br />
                </div>
                <hr />
                <div>
                  <u>
                    <h2 style={{ fontSize: "16px" }}>
                      Langkah 4: Verifikasi Hasil
                    </h2>
                  </u>
                  <p>
                    Setelah melakukan konversi, pastikan teks yang dihasilkan sesuai dengan angka
                    yang Anda masukkan. Langkah ini penting untuk memastikan akurasi dalam penulisan.
                  </p>
                  <div className="p-3 mb-2 bg-info text-black ">
                    Ingat: Selalu verifikasi nilai yang dimasukkan dan teks yang dihasilkan untuk memastikan akurasi.
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
         </div>
</div>
  );
}
export default CurrencyConverter;